module.exports = __webpack_public_path__ + "media/bootstrap-icons/gender-trans-544cf7fe.svg";